module.exports = __webpack_public_path__ + "static/media/loewy-1.2b1cb377.jpg";